exports.install = function (Vue, options) {
	//token检测
	Vue.prototype.check = function()
	{
		this.axiosget("/api/token/check");
	};
}